
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-money-input-config",
})
export default class MoneyInputConfig extends ComponentConfigMixins {}
